import axios from 'axios'
import { jwtDecode } from 'jwt-decode'

import { tracerError } from '../../sideEffects.container'

export const logoutKeycloak = (refreshToken: string, realm: string) => {
  return axios.post(
    `auth-adapter/api/v1/auth/realms/${realm ?? 'BUILDDOCS'}/logout`,
    { refreshToken: refreshToken },
  )
}

export const refreshTokenByModernRefresh = (
  refreshToken: string,
  email: string,
  realm: string,
) => {
  return axios
    .put(
      `auth-adapter/api/v1/auth/realms/${
        realm ?? 'BUILDDOCS'
      }/token?username=${email}`,
      { refresh_token: refreshToken },
    )
    .then(res => res.data)
    .catch(e => {
      tracerError.error(e, {
        severity: 'warning',
        component: 'auth-adapter',
        keys: {
          userEmail: email,
          realm: realm ?? 'UNDEFINED',
          action: 'refreshTokenByModernRefresh',
        },
      })
      throw e
    })
}

export const getTokenFromOldRefreshToken = (refreshToken: string) => {
  const realm = localStorage.getItem('REALM')

  const refreshBody = jwtDecode<{ email: string; userId: string }>(refreshToken)

  return axios
    .post<{ accessToken: string; refreshToken: string }>(
      `auth-adapter/api/v1/auth/realms/${realm ?? 'BUILDDOCS'}/token?username=${
        refreshBody.email
      }`,
      { callback_token: refreshToken },
    )
    .then(res => res?.data ?? null)
    .catch(e => {
      tracerError.error(e, {
        severity: 'warning',
        component: 'auth-adapter',
        userId: refreshBody.userId,
        keys: {
          userEmail: refreshBody.email,
          realm: realm ?? 'UNDEFINED',
          action: 'getTokenFromOldRefreshToken',
        },
      })
      throw e
    })
}
